import { Textarea } from '@cian/ui-kit';
import { ArrowBackward16 } from '@cian/ui-kit/prev';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './styles.css';
import { useMessageInput, MAX_MESSAGE_LENGTH } from './useMessageInput';

type TMessageInputFieldProps = {
  chatId: string;
  attachFileButton: React.ReactNode | null;
  hintQuestions: React.ReactNode | null;
  captcha?: React.ReactNode | null;
  isLoading: boolean;
  isDisabled: boolean;
  onSend(params: { text: string; chatId: string; captchaToken?: string | null }): void;
  onHeightChange(): void;
  placeholder?: string;
};

export const MessageInputField: React.VFC<TMessageInputFieldProps> = ({
  chatId,
  captcha,
  attachFileButton,
  isLoading,
  isDisabled,
  onSend,
  onHeightChange,
  hintQuestions,
  placeholder,
}) => {
  const { text, onKeyDown, onValueChange, onBlur, trySend } = useMessageInput({
    chatId,
    onSend,
    onHeightChange,
  });

  return (
    <div className={styles['container']} data-name="MessageInputField">
      {hintQuestions && <div className={styles['hint-questions']}>{hintQuestions}</div>}
      <div className={styles['wrapper']}>
        {captcha && <div className={styles['captcha']}>{captcha}</div>}
        <div className={styles['inner-container']}>
          {attachFileButton}
          <Textarea
            value={text}
            onChange={onValueChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            placeholder={placeholder || 'Написать сообщение'}
            disabled={isDisabled || isLoading}
            maxRows={10}
            minRows={1}
            maxLength={MAX_MESSAGE_LENGTH}
            size="M"
            data-name="MessageInputField_textarea"
          />
          <button
            onClick={trySend}
            disabled={!text.length || isLoading || isDisabled}
            {...mergeStyles(styles['button-wrapper'], Boolean(text.length) && styles['button-wrapper--active'])}
            data-testid="send_button"
            data-name="MessageInputField_send_button"
          >
            <ArrowBackward16 />
          </button>
        </div>
      </div>
    </div>
  );
};
